'use strict';

/**
 * Card.
 */
var PromotionCard = (function(window, undefined) {

 // console.log("promotion card started loading")

  /**
   * Enum of CSS selectors.
   */
  var SELECTORS = {
    container: '.card__container',
    content: '.card__content',
    clip: '.clip'
  };

  /**
   * Enum of CSS classes.
   */
  var CLASSES = { 
    bodyHidden: 'body--hidden'
  };

  var hideBeforeClipIn;

  /**
   * Card.
   */
  function PromotionCard(id, el) {

    this.id = id;

    this._el = el;

    // Get elements.
    this._container = cash(this._el).find(SELECTORS.container)[0];
    this._clip = cash(this._el).find(SELECTORS.clip)[0];
    this._content = cash(this._el).find(SELECTORS.content)[0];

    this.isOpen = false;

    this._TL = null;
  };

  /**
   * Open card.
   * @param {Function} callback The callback `onCardMove`.
   */
  PromotionCard.prototype.openCard = function(callback) {

    this._TL = new TimelineLite;

    var slideContentDown = this._slideContentDown();
    var clipImageIn = this._clipImageIn();
    var floatContainer = this._floatContainer(callback);
    var clipImageOut = this._clipImageOut();
    var slideContentUp = this._slideContentUp();

    // Compose sequence and use duration to overlap tweens.
  //  this._TL.add(slideContentDown);
 //   this._TL.add(clipImageIn, 0);
  //  this._TL.add(floatContainer, '-=' + clipImageIn.duration() * 0.016);
  //  this._TL.add(clipImageOut, '-=' + floatContainer.duration() * 0.013, "now");
    this._TL.add(slideContentUp, '-=' + floatContainer.duration() * 0.007, 'now');


   // hideBeforeClipIn = clipImageIn.duration() * 0.016 + floatContainer.duration() * 0.013 + clipImageOut.duration() * 0.016;

   // hideBeforeClipIn = clipImageIn.duration() * 0.016 + floatContainer.duration() * 0.013 + clipImageOut.duration() * 0.016;

    this.isOpen = true;

    return this._TL;
  };

  /**
   * Slide content down.
   * @private
   */
  PromotionCard.prototype._slideContentDown = function() {

    var tween = TweenLite.to(this._content, 0.08, {
      y: window.innerHeight,
      
    });

    return tween;
  };

  /**
   * Clip image in.
   * @private
   */
  PromotionCard.prototype._clipImageIn = function() {

    // Circle.
    var tween = TweenLite.to(this._clip, 0.08, {
      attr: {
        r: 50
      },
 
    });

    return tween;
  };

  /**
   * Float card to final position.
   * @param {Function} callback The callback `onCardMove`.
   * @private
   */
  PromotionCard.prototype._floatContainer = function(callback) {

    cash(document.body).addClass(CLASSES.bodyHidden);

    var TL = new TimelineLite;

    var rect = this._container.getBoundingClientRect();
    var windowW = window.innerWidth;

    var track = {
      width: 0,
      x: rect.left + (rect.width / 2),
      y: rect.top + (rect.height / 2),
    };

    TL.set(this._container, {
      width: rect.width,
      height: rect.height,
      x: rect.left,
      y: rect.top,
      position: 'fixed',
      overflow: 'hidden'
    });

    TL.to([this._container, track], 2, {
      width: windowW,
      height: '100%',
      x: windowW / 2,
      y: 0,
      xPercent: -50,

      clearProps: 'all',
      className: '-=' + CLASSES.containerClosed,
      onUpdate: callback.bind(this, track)
    });

    return TL;
  };

  /**
   * Clip image out.
   * @private
   */
  PromotionCard.prototype._clipImageOut = function() {

    // Circle.
    var radius = cash(this._clip).attr('r');

    var tween = this._clipImageIn();

    tween.vars.attr.r = radius;

    return tween;
  };

  /**
   * Slide content up.
   * @private
   */
  PromotionCard.prototype._slideContentUp = function() {

    var tween = TweenLite.to(this._content, 1, {
      y: 0,
      clearProps: 'all',
     
    });

    return tween;
  };

  /**
   * Close card.
   */
  PromotionCard.prototype.closeCard = function() {

    TweenLite.to(this._container, 0.04, {
      scrollTo: {
        y: 0
      },
      onComplete: function() {
        cash(this._container).css('overflow', 'hidden');
      }.bind(this),
      
    });

    this._TL.eventCallback('onReverseComplete', function() {

      TweenLite.set([this._container, this._content], {
        clearProps: 'all'
      });

      cash(document.body).removeClass(CLASSES.bodyHidden);

      this.isOpen = false;

    }.bind(this));

    setTimeout(function(){
     // console.log(hideBeforeClipIn);
      $('#promotion-detail').css({
        'display' : "none",
        'opacity' : 0,
        'z-index' : -1
      });
    },hideBeforeClipIn * 1000);

    return this._TL.reverse();
  };

  /**
   * Hide card, called for all cards except the selected one.
   */
  PromotionCard.prototype.hideCard = function() {

    var tween = TweenLite.to(this._el, 0.04, {
      scale: 1,
      autoAlpha: 0,
      transformOrigin: 'center bottom',
    
    });

    return tween;
  };

  /**
   * Show card, called for all cards except the selected one.
   */
  PromotionCard.prototype.showCard = function() {

    var tween = TweenLite.to(this._el, 0.05, {
      scale: 1,
      autoAlpha: 1,
      clearProps: 'all',
      
    });

    return tween;
  };

//  console.log("promotion card finished loading")

  return PromotionCard;

})(window);
